import { defineMessages } from "react-intl";

const messages = defineMessages({
  addressChanged: {
    id: "recordPane.address.addressChanged",
    defaultMessage:
      "Coordinates were changed and the address was updated to accurately reflect the new position.",
    description: "Address and coordinates changed alert",
  },
  alert: {
    id: "recordPane.address.alert",
    defaultMessage: "Manual changes to coordinates might update the existing street address.",
    description: "Change coordinates alert",
  },
  cancel: {
    id: "recordPane.address.cancel",
    defaultMessage: "Cancel",
    description: "Cancel button text",
  },
  changeCoordinates: {
    id: "recordPane.address.changeCoordinates",
    defaultMessage: "Change Coordinates",
    description: "A tooltip for Location Coordinates",
  },
  changeManually: {
    id: "recordPane.address.changeManually",
    defaultMessage: "Change Manually",
    description: "Change Manually dropdown option",
  },
  changeOnMap: {
    id: "recordPane.address.changeOnMap",
    defaultMessage: "Change on Map",
    description: "Change on Map dropdown option",
  },
  coordinatesChanged: {
    id: "recordPane.address.coordinatesChanged",
    defaultMessage:
      "Coordinates were changed, but the address has remained the same. Pin position might be slightly altered on the map upon save.",
    description: "Coordinates changed alert",
  },
  getCoordinates: {
    id: "recordPane.address.getCoordinates",
    defaultMessage: "Save to get coordinates",
    description: "Get coordinates message on address change",
  },
  label: {
    id: "recordPane.address.label",
    defaultMessage: "Address",
    description: "Entity address block title in the Preview panes",
  },
  latitude: {
    id: "recordPane.address.latitude",
    defaultMessage: "Latitude",
    description: "Latitude field label at Company Edit Pane",
  },
  longitude: {
    id: "recordPane.address.longitude",
    defaultMessage: "Longitude",
    description: "Longitude field label at Company Edit Pane",
  },
  noCoordinates: {
    id: "recordPane.address.noCoordinates",
    defaultMessage: "No coordinates",
    description: "No coordinates label",
  },
  nonEditable: {
    id: "recordPane.address.nonEditable",
    defaultMessage: "Record is unable to mapped because address is protected information",
    description:
      "Tooltip for the Entity address field in the Preview panes when address is not editable",
  },
  ok: {
    id: "recordPane.address.ok",
    defaultMessage: "Okay",
    description: "Okay button text",
  },
  undo: {
    id: "recordPane.address.undo",
    defaultMessage: "Undo",
    description: "Undo button",
  },
});

export default messages;
